<template>
  <div class="cost-centers" :class="{'cost-centers-container': isInSchoolSalarySettings}">
    <Loader v-if="isLoading" :bg-color="isInSchoolSalarySettings ? '#edf0f5' : '#fff'"></Loader>
    <template v-else>
      <table class="do-table do-table__items do-table--striped">
        <thead>
        <th>Kode</th>
        <th>Omkostningssted</th>
        <th style="width: 60%;">
          <button class="do-bttn do-bttn--submit" @click="setIsCreateItemModal(true)">
            Opret omkostningssted
          </button>
        </th>
        </thead>
        <tbody>
        <tr v-if="costCenters.length === 0">
          <td colspan="2">
            <i>Ingen oprettet</i>
          </td>
          <td></td>
        </tr>
        <CostCentersCenter
          v-for="cc in costCenters"
          :key="cc.id"
          :item="cc"
          :calendars="calendars"
          :calendarNames="calendarNames"
          :initialSelectedCalendarIds="getInitialIdsFor(cc.id)"
          :isInSchoolSalarySettings="isInSchoolSalarySettings"
          :isUpdating="updatingCostCenterId === cc.id"
          @save="onSaveRule"
          @archive="archiveCostCenter"
        />
        </tbody>
      </table>
      <p
        class="text-link marg-1-top"
        v-if="archivedCostCenters.length > 0"
        @click="isShowArchived = !isShowArchived">
        {{ isShowArchived ? 'Skjul arkiverede' : 'Vis arkiverede' }}
        {{ '(' + archivedCostCenters.length + ')' }}
      </p>
      <table
        class="do-table do-table__items do-table--striped marg-1-top"
        v-if="isShowArchived && archivedCostCenters.length > 0">
        <thead>
        <th>Kode</th>
        <th>Omkostningssted</th>
        <th style="width: 60%;"></th>
        </thead>
        <tbody>
        <CostCentersCenter
          v-for="cc in archivedCostCenters"
          :key="cc.id"
          :item="cc"
          :calendars="calendars"
          :calendarNames="calendarNames"
          :initialSelectedCalendarIds="getInitialIdsFor(cc.id)"
          :isInSchoolSalarySettings="isInSchoolSalarySettings"
          :isUpdating="updatingCostCenterId === cc.id"
          @save="onSaveRule"
          @archive="archiveCostCenter"
        />
        </tbody>
      </table>
    </template>
    <TableCreateModal
      v-if="isCreateItemModal"
      :theType="'omkostningssteder'"
      :theEditItem="theEditItem"
      :isSubmitting="isSubmitting"
      :isDeleting="isDeleting"
      @onSubmit="onCreate"
      @close="setIsCreateItemModal">
    </TableCreateModal>
  </div>
</template>

<script>
import TableCreateModal from './TableCreateModal.vue'
import Loader from '../../common/Loader.vue'
import DoFiltersFilter from '../../DoFilters/DoFiltersFilter.vue'
import CostCentersCenter from './CostCentersCenter.vue'

export default {
  components: {CostCentersCenter, DoFiltersFilter, Loader, TableCreateModal},
  props: {
    costCenterRules: {
      type: Array,
      default: () => []
    },
    isInSchoolSalarySettings: {
      default: true
    }
  },
  data () {
    return {
      isCreateItemModal: false,
      theEditItem: null,
      isDeleting: false,
      isAwaitingCloseModal: false,
      costCenterRulesBuffer: [],
      isShowArchived: false,
      updatingCostCenterId: null
    }
  },
  computed: {
    activeSchool () {
      return this.$store.getters.schoolId
    },
    costCenters () {
      return this.$store.getters.costCenters
    },
    archivedCostCenters () {
      return this.$store.getters.costCentersArchived
    },
    isLoading () {
      return this.$store.state.employments.isLoadingCostCenters
    },
    isSubmitting () {
      return this.$store.state.employments.isUpdatingCostCenters
    },
    klassCalendars () {
      return this.$store.getters.klassCalendars
    },
    otherCalendars () {
      return this.$store.getters.otherCalendars
    },
    clubCalendars () {
      return this.$store.getters.clubCalendars
    },
    calendars () {
      return []
        .concat(this.klassCalendars || [])
        .concat(this.otherCalendars || [])
        .concat(this.clubCalendars || [])
    },
    calendarNames () {
      return this.calendars.map(calendar => calendar.name)
    },
    ruleMap () {
      const map = {}
      const rules = Array.isArray(this.costCenterRules) ? this.costCenterRules : []
      rules.forEach(r => {
        map[r.selected_cost_center_id] = Array.isArray(r.calendar_ids) ? r.calendar_ids : []
      })
      return map
    }
  },
  watch: {
    isSubmitting (val, oldVal) {
      if (this.isAwaitingCloseModal && !val) {
        this.isAwaitingCloseModal = false
        this.setIsCreateItemModal(false)
      }
    },
    watch: {
      costCenterRules: {
        handler (val) {
          const arr = Array.isArray(val) ? val : []
          // dyb kopi så vi kan redigere lokalt
          this.costCenterRulesBuffer = JSON.parse(JSON.stringify(arr))
        },
        immediate: true,
        deep: true
      }
    }
  },
  methods: {
    onSaveRule (rule) {
      const idx = this.costCenterRulesBuffer.findIndex(r => r.selected_cost_center_id === rule.selected_cost_center_id)
      if (idx > -1) {
        this.costCenterRulesBuffer.splice(idx, 1, rule)
      } else {
        this.costCenterRulesBuffer.push(rule)
      }
      this.$emit('updateCostCenterRules', this.costCenterRulesBuffer)
    },
    getInitialIdsFor (costCenterId) {
      return this.ruleMap[costCenterId] || []
    },
    prefilledIdsFor (costCenterId) {
      return this.getInitialIdsFor(costCenterId)
    },
    setIsCreateItemModal (bool) {
      this.isCreateItemModal = bool
      if (!bool) {
        this.theEditItem = null
      }
    },
    setEditItem (item) {
      this.theEditItem = item
      this.isCreateItemModal = true
    },
    onCreate (costCenter) {
      this.isAwaitingCloseModal = true
      this.$store.dispatch('createCostCenter', costCenter)
    },
    archiveCostCenter (costCenter) {
      this.updatingCostCenterId = costCenter.id
      this.$store.dispatch('archiveCostCenter', costCenter).finally(() => {
        this.updatingCostCenterId = null
      })
    }
  },
  mounted () {
    this.$store.dispatch('readSalaryCodes')
    this.$store.dispatch('readCostCenters')
  }
}
</script>

<style scoped>

.cost-centers {
  width: 600px;
}

.cost-centers.cost-centers-container {
  padding: 1rem;
  width: 100%;
  max-width: 1440px;
}

.do-table__items tbody tr {
  border-bottom: 1px solid #eee;
}

.do-table__items tbody td {
  border-left: 1px solid #eee;
}

.do-table__items tbody td:last-child {
  min-width: 80%;
}

.do-table__items tr:hover {
  background-color: aliceblue !important;
}

.do-table__items th:last-child {
  text-align: right;
}

.do-table__items tr > td:last-child {
  display: flex;
  justify-content: flex-end;
}

.text-link {
  cursor: pointer;
  color: #468AD7;
}

.text-link:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// CostCenters.vue?5094bb41